import BasicCrudScreenType from "../screenTypes/functional/BasicCrudScreenType";
import { useEffect, useState } from 'react';
import { useTranslation } from "react-i18next";
import { ReflexContainer, ReflexElement, ReflexSplitter } from "react-reflex";
import layoutConf from "../../config/layoutConf";
import {debounce} from "lodash";
import TkMaterialStatusDetail from "./TkMaterialStatusDetail";

function MomSysMaterialStatus ( props ) {

    const [ grid, setGrid ] = useState();

    const [onSelectMst, setOnSelectMst] = useState();

    const [ height, setHeight ] = useState(0);
    
    const { t } = useTranslation();

    useEffect(() => {

        window.addEventListener('resize', handleResize);
        handleResize();

        return ( () => {
            window.removeEventListener('resize', handleResize);
        } );


    }, []);

    useEffect(() => {

        (async () => {

            if (grid) {

                grid.selectionChanged.addHandler(debounce((grid, event) => {

                    if (grid.selectedItems && grid.selectedItems[0]) {

                        setOnSelectMst(grid.selectedItems[0])

                    } else {

                        setOnSelectMst([]);

                    };

                }), 10);

                grid.itemsSourceChanged.addHandler(debounce((grid, event) => {

                    if (grid.selectedItems && grid.selectedItems[0]) {

                        setOnSelectMst(grid.selectedItems[0])

                    } else {

                        setOnSelectMst([]);

                    };

                }), 10);
            }

        })()

    }, [grid])

    const handleResize = () => {

        setHeight(document.documentElement.offsetHeight - 96);

    };

    const onInitialized = ( grid ) => {

        grid.selectionMode = "Row";
        setGrid(grid)
        
    };

    return (

        <div style={{ height: height }} >

            <ReflexContainer orientation="horizontal">

                <ReflexElement flex={0.6}>

                    <BasicCrudScreenType 
                        id="TkVwMaterialInventorySummary" 
                        view="TkVwMaterialInventorySummary" 
                        headerTitle={t("term.materialList")}
                        noCreate
                        noEdit
                        noDelete
                        noExcel
                        onInitialized={onInitialized}
                        
                    />

                </ReflexElement>

                <ReflexSplitter style={{ height: layoutConf.reflex.splitterHeight }} />

                <ReflexElement>

                {
                        (onSelectMst)
                            ?
                            <TkMaterialStatusDetail
                                onSelectMst={onSelectMst}
                                materialType = "material"
                                headerTitle = {t("term.materialStatus")}
                            />
                            :
                            <></>
                    }


                </ReflexElement>

        </ReflexContainer>

        </div>

    );

}

export default MomSysMaterialStatus;
